<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import { useSessionDetailsDocumentsStore } from "~/store/sessions/session-details-documents-store";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const sessionDetailsDocumentsStore = useSessionDetailsDocumentsStore();
const { showSessionRemoveDocumentModal } = storeToRefs(sessionDetailsDocumentsStore);

const emit = defineEmits(["resetToggleShowMore"]);

function hideModal() {
  showSessionRemoveDocumentModal.value = false;
}

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
});

async function removeDocument() {
  if (props.documentId) {
    await sessionDetailsDocumentsStore.removeSessionDocument(props.documentId);
    emit("resetToggleShowMore");
    hideModal();
  }
}
</script>

<template>
  <CenterModal style="width: 420px" @hide="hideModal">
    <template #body>
      <div class="p-[24px]">
        <h3 class="heading_3_med text-primary-color pb-[12px]">Voulez-vous supprimer ce document ?</h3>
        <div class="flex gap-[18px] justify-end gap pt-[16px]">
          <AppButton type="outlined" label="Annuler" class="w-full" @click="hideModal" />
          <AppButton label="Oui, supprimer" class="w-full" variant="error" @click="removeDocument" />
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped></style>
